'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.setSetting = setSetting;
exports.loadSettings = loadSettings;

var _constants = require('redux/constants');

function setSetting(params) {
    return {
        type: _constants.SettingConstants.SET_SETTING,
        result: params
    };
}

function loadSettings(domain) {
    return {
        types: [_constants.SettingConstants.LOAD_SETTINGS, _constants.SettingConstants.LOAD_SETTINGS_SUCCESS, _constants.SettingConstants.LOAD_SETTINGS_FAIL],
        promise: function promise(client, iBonus) {
            return iBonus.getDomainInfo(domain);
        }
    };
}


//////////////////
// WEBPACK FOOTER
// ./src/redux/actions/setting.js
// module id = 1863
// module chunks = 0